<template>
  <sdPageHeader :title="$t('pages.apps.title')"
    ><template v-slot:buttons>
      <div class="page-header-actions">
        <router-link :to="{ name: 'new-general' }">
          <sdButton size="small" type="primary" @click="allRead">
            <sdFeatherIcons type="plus" size="14" />
            {{ $t('pages.apps.add-new') }}
          </sdButton>
        </router-link>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <sdCards>
      <a-row :gutter="16">
        <a-col :span="4">
          <label> {{ $t('pages.apps.table-category') }} </label>
          <a-select :placeholder="$t('common.choose')" style="width: 100%" v-model:value="filter.category">
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="category.id" v-for="category in categories" :key="category">
              {{ $store.state.i18n.i_lang == 'en' ? category.title_en : category.title }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> {{ $t('pages.apps.review-process') }} </label>
          <a-select :placeholder="$t('common.choose')" style="width: 100%" v-model:value="filter.reviewProcess">
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="review.id" v-for="review in reviews" :key="review">
              {{ $store.state.i18n.i_lang == 'en' ? review.title_en : review.title }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> {{ $t('pages.apps.activity') }} </label>
          <a-select :placeholder="$t('common.choose')" style="width: 100%" v-model:value="filter.active">
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('common.active') }}
            </a-select-option>
            <a-select-option :value="0">
              {{ $t('common.passive') }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> {{ $t('pages.apps.draft') }} </label>
          <a-select :placeholder="$t('common.choose')" style="width: 100%" v-model:value="filter.draft">
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('pages.apps.in-draft') }}
            </a-select-option>
            <a-select-option :value="0">
              {{ $t('pages.apps.not-in-draft') }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          {{ $t('common.search') }}
          <SearchBoxVue v-model:text="filter.search" />
        </a-col>
        <a-col :span="1">
          <label> &nbsp;</label>
          <sdButton size="small" type="info" @click="onClickFilter">
            {{ $t('common.filter') }}
          </sdButton>
        </a-col>
      </a-row>
      <br />
      <br />
      <div v-if="isLoading" class="spin">
        <a-spin />
      </div>
      <div v-else>
        <a-table
          :pagination="{
            pageSize: this.filter.pageSize,
            showSizeChanger: true,
            total: this.filter.total,
            current: this.filter.current,
          }"
          @change="onTableChange"
          :columns="columns"
          :data-source="records"
          size="small"
        >
          <template #image="{ record }">
            <a-space>
              <div class="record-img align-center-v">
                <img :src="record.image" style="height: 40px; max-width: 150px" />
              </div>
            </a-space>
          </template>
          <template #price="{ record }">
            <a-space>
              <a-tag color="cyan" v-if="record.price == '0.00'">{{ $t('pages.apps.table-free') }}</a-tag>
              <a-tag color="blue" v-if="record.price != '0.00'">
                {{ record.price }}
                {{ record.vat != '0' ? '+ ' + $t('pages.apps.table-vat') : '' }}
                {{ record.currency == '' || record.currency == 'TRY' ? 'TL' : record.currency }}
              </a-tag>
            </a-space>
          </template>
          <template #is_publish="{ record }">
            <a-space>
              <a-tag :color="record.is_publish ? 'green' : 'red'">
                {{ record.is_publish ? $t('pages.apps.table-published') : $t('pages.apps.table-not-published') }}
              </a-tag>
            </a-space>
          </template>
          <template #review="{ record }">
            <a-space>
              <ReviewProcess :id="record.review_process_id" :text="record.review_processe" />
            </a-space>
          </template>
          <template #version="{ record }">
            <a-space>
              <router-link :to="'/applications/detail/' + record.id + '/release-notes'">
                {{ record.version }}
              </router-link>
            </a-space>
          </template>
          <template #action="{ record }">
            <a-space>
              <router-link :to="'/applications/detail/' + record.id + '/general'">
                <a-button type="primary">
                  <template #icon> <sdFeatherIcons type="edit" style="color: white" /> </template>
                </a-button>
              </router-link>
              <a-button :href="host_url + record.seo_url" target="_blank" type="primary">
                <template #icon> <sdFeatherIcons type="external-link" style="color: white" /> </template>
              </a-button>
              <a-button v-if="false" @click="deleteModule(record.id)" type="primary">
                <template #icon> <sdFeatherIcons type="trash-2" /> </template>
              </a-button>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { dateToTr } from '@/utility/helper';
import ReviewProcess from '@/components/application/ReviewProcess';
import SearchBoxVue from '@/components/search/SearchBox.vue';

export default {
  name: 'AppList',
  components: {
    Main,
    ReviewProcess,
    SearchBoxVue,
  },
  data() {
    return {
      host_url: process.env.VUE_APP_HOST_URL,
      isLoading: true,
      filter: {
        category: null,
        reviewProcess: null,
        active: null,
        draft: null,
        search: null,
        current: 1,
        pageSize: 10,
        total: null,
      },
      records: [],
      columns: [
        {
          key: 0,
          title: 'Logo',
          dataIndex: 'image',
          key: 'image',
          slots: { customRender: 'image' },
        },
        {
          key: 0,
          title: this.$t('pages.apps.table-name'),
          dataIndex: 'title',
          key: 'title',
          ellipsis: true,
        },
        {
          title: this.$t('pages.apps.table-price'),
          dataIndex: 'price',
          key: 'price',
          slots: { customRender: 'price' },
        },
        {
          title: this.$t('pages.apps.table-status'),
          dataIndex: 'is_publish',
          key: 'is_publish',
          slots: { customRender: 'is_publish' },
        },
        {
          title: this.$t('pages.apps.table-review'),
          dataIndex: 'review_processe',
          key: 'review_processe',
          slots: { customRender: 'review' },
        },
        {
          title: this.$t('pages.apps.table-commission-rate'),
          dataIndex: 'commission_rate',
          key: 'commission_rate',
        },
        {
          title: this.$t('pages.apps.table-version'),
          dataIndex: 'version',
          key: 'version',
          slots: { customRender: 'version' },
        },
        {
          title: this.$t('pages.apps.table-install-count'),
          dataIndex: 'install_count',
          key: 'install_count',
        },
        {
          title: this.$t('pages.apps.actions'),
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      categories: [],
      reviews: [],
    };
  },
  methods: {
    get() {
      this.isLoading = true;
      this.records = [];
      this.$appAxios.post(this.$endpoints.app_get, this.filter).then((resp) => {
        if (resp.data.status) {
          var _this = this;
          _this.filter.total = resp.data.data.count;
          resp.data.data.records.forEach(function (item, index) {
            _this.records.push({
              key: item.id,
              id: item.id,
              title: item.title,
              category: _this.$store.state.i18n.i_lang == 'en' ? item.category_title_en : item.category_title,
              price: item.price,
              image: item.image,
              seo_url: item.seo_url,
              install_count: item.install_count,
              update_date: dateToTr(item.update_date),
              vat: item.vat,
              currency: item.currency,
              version: item.version,
              is_publish: item.is_publish,
              commission_rate: '%' + item.commission_rate,
              review_processe:
                _this.$store.state.i18n.i_lang == 'en' ? item.review_process_title_en : item.review_process_title,
              review_process_id: item.review_process_id,
            });
          });
          this.isLoading = false;
        }
      });
    },
    onClickFilter() {
      this.filter.current = 1;
      this.get();
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.get();
    },
    getCategories() {
      this.$appAxios.post(this.$endpoints.categories_get).then((resp) => {
        if (resp.data.status) {
          this.categories = resp.data.data;
        }
      });
    },
    getReviewProcesses() {
      this.$appAxios.post(this.$endpoints.reviews_processes_get).then((resp) => {
        if (resp.data.status) {
          this.reviews = resp.data.data;
        }
      });
    },
  },
  created() {
    this.get();
    this.getCategories();
    this.getReviewProcesses();
  },
};
</script>